module.exports = __webpack_public_path__ + "static/RIF-a052f9b90eec042a48d42d6e9f32a316.svg";